/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AccessSourceResponse,
    AddressRequest,
    AppSellerApplicationResponse,
    ApplyChangePayoutMethodDto,
    ApplyStripePayoutMethodRequest,
    AuditChangePayoutMethodDto,
    AuthTokenResponse,
    AuthUserItem,
    BlockAccessSource,
    BlockAccessSourceResponse,
    BlockUserCommentRequest,
    CheckPayoutMethodUpdateStatusResponse,
    CreateFollowerDto,
    CreateGuestUserRequest,
    CreatePayoutMethodDto,
    CreatePayoutMethodResponse,
    CreateStripePayoutMethodRequest,
    CreateStripePayoutMethodResponse,
    CreateUserParamsV2,
    EditStripePayoutMethodResponse,
    EnsureAddressResponse,
    ExecuteClaimActionRequest,
    GetAccessResponse,
    GetFeatureResponse,
    GetPhoneResponse,
    GetPublicFeatureResponse,
    GetSellerMetricsResponse,
    GetUserMetricsResponse,
    GetUserTokenRequest,
    LinkAccountResponse,
    LinkUserDto,
    LoginRequest,
    LoginSessionResponse,
    LogoutRequest,
    MergeAccountDto,
    ModifyReceivedGiftListingRequest,
    OneTimeLoginCodeDto,
    PatchReadonlyProfileRequest,
    SellerBalanceResponse,
    SetPayoutMethodDto,
    SetReferrerRequest,
    SetUrlCodeDto,
    SetUserPasswordRequest,
    StripePayoutMethodResponse,
    UnBlockAccessSourceResponse,
    UnlinkSignInProvidersRequest,
    UpdateAddressResponse,
    UpdateBlockUserCommentRequest,
    UpdateBuyerAddressRequest,
    UpdateCategoryRequest,
    UpdateRequest,
    UpdateUserParams,
    UpdateUserParamsV2,
    UpdateUserPhoneNumber,
    UpdateWithdrawableBalanceByAdminRequest,
    ValidateUsername,
    ValidateUsernameResponse,
    WatchSellerRequest,
} from '../models';

export interface UserApiControllerAddUserToBlockListRequest {
    userId: string;
    blockedUserId: string;
}

export interface UserApiControllerApplyChangePayoutMethodRequest {
    userId: string;
    applyChangePayoutMethodDto: ApplyChangePayoutMethodDto;
}

export interface UserApiControllerApplyChangeStripePayoutMethodRequest {
    userId: string;
    applyStripePayoutMethodRequest: ApplyStripePayoutMethodRequest;
}

export interface UserApiControllerApproveChangePayoutMethodRequest {
    userId: string;
    auditChangePayoutMethodDto: AuditChangePayoutMethodDto;
}

export interface UserApiControllerBlockAccessSourceRequest {
    blockAccessSource: BlockAccessSource;
}

export interface UserApiControllerBlockUserCommentRequest {
    userId: string;
    blockUserCommentRequest: BlockUserCommentRequest;
}

export interface UserApiControllerCheckPayoutMethodUpdateStatusRequest {
    userId: string;
}

export interface UserApiControllerCheckUserDefaultAddressRequest {
    userId: string;
}

export interface UserApiControllerCreateFollowerRequest {
    userId: string;
    createFollowerDto: CreateFollowerDto;
}

export interface UserApiControllerCreateGuestUserRequest {
    createGuestUserRequest: CreateGuestUserRequest;
    xPopPlatform?: UserApiControllerCreateGuestUserXPopPlatformEnum;
}

export interface UserApiControllerCreatePayoutMethodRequest {
    userId: string;
    createPayoutMethodDto: CreatePayoutMethodDto;
}

export interface UserApiControllerCreateRoleRequest {
    userId: string;
    role: string;
}

export interface UserApiControllerCreateStripePayoutMethodRequest {
    userId: string;
    createStripePayoutMethodRequest: CreateStripePayoutMethodRequest;
}

export interface UserApiControllerCreateUserV2Request {
    userId: string;
    createUserParamsV2: CreateUserParamsV2;
}

export interface UserApiControllerDeleteRoleRequest {
    userId: string;
    role: string;
}

export interface UserApiControllerExchangeOneTimeLoginCodeRequest {
    oneTimeLoginCodeDto: OneTimeLoginCodeDto;
}

export interface UserApiControllerExecuteClaimActionRequest {
    userId: string;
    executeClaimActionRequest: ExecuteClaimActionRequest;
}

export interface UserApiControllerGetAccessSourcesRequest {
    userId: string;
}

export interface UserApiControllerGetAuthInfoRequest {
    userId: string;
}

export interface UserApiControllerGetBalanceRequest {
    userId: string;
}

export interface UserApiControllerGetFeaturesRequest {
    userId: string;
}

export interface UserApiControllerGetLatestAppSellerApplicationRequest {
    userId: string;
}

export interface UserApiControllerGetPhoneRequest {
    phone: string;
}

export interface UserApiControllerGetPublicFeaturesRequest {
    userId: string;
}

export interface UserApiControllerGetSellerMetricsRequest {
    sellerId: string;
}

export interface UserApiControllerGetStripePayoutMethodRequest {
    userId: string;
}

export interface UserApiControllerGetUserLastLoginSessionRequest {
    userId: string;
    appId: string;
}

export interface UserApiControllerGetUserMetricsRequest {
    userId: string;
}

export interface UserApiControllerGetUserTokenRequest {
    userId: string;
    getUserTokenRequest: GetUserTokenRequest;
}

export interface UserApiControllerLinkRequest {
    userId: string;
    linkUserDto: LinkUserDto;
}

export interface UserApiControllerLoginRequest {
    userId: string;
    loginRequest: LoginRequest;
}

export interface UserApiControllerLogoutRequest {
    userId: string;
    logoutRequest: LogoutRequest;
}

export interface UserApiControllerMergeAccountRequest {
    userId: string;
    mergeAccountDto: MergeAccountDto;
}

export interface UserApiControllerModifyReceivedGiftListingRequest {
    receiverId: string;
    sentReferralGiftId: string;
    modifyReceivedGiftListingRequest: ModifyReceivedGiftListingRequest;
}

export interface UserApiControllerPatchReadonlyProfileRequest {
    userId: string;
    patchReadonlyProfileRequest: PatchReadonlyProfileRequest;
}

export interface UserApiControllerRejectChangePayoutMethodRequest {
    userId: string;
    auditChangePayoutMethodDto: AuditChangePayoutMethodDto;
}

export interface UserApiControllerRemoveFollowerRequest {
    userId: string;
    followerId: string;
}

export interface UserApiControllerRemoveUserFromBlockListRequest {
    userId: string;
    blockedUserId: string;
}

export interface UserApiControllerRestoreUserCommentRequest {
    userId: string;
}

export interface UserApiControllerReverseMergeAccountRequest {
    userId: string;
    mergeAccountDto: MergeAccountDto;
}

export interface UserApiControllerSetPayoutMethodRequest {
    userId: string;
    setPayoutMethodDto: SetPayoutMethodDto;
}

export interface UserApiControllerSetProfileUrlCodeRequest {
    userId: string;
    setUrlCodeDto: SetUrlCodeDto;
}

export interface UserApiControllerSetUserPasswordRequest {
    userId: string;
    setUserPasswordRequest: SetUserPasswordRequest;
}

export interface UserApiControllerSetUserReferrerRequest {
    userId: string;
    setReferrerRequest: SetReferrerRequest;
}

export interface UserApiControllerUnblockAccessSourceRequest {
    sourceId: string;
}

export interface UserApiControllerUnlinkSignInProvidersRequest {
    userId: string;
    unlinkSignInProvidersRequest: UnlinkSignInProvidersRequest;
}

export interface UserApiControllerUpdateBuyerAddressRequest {
    userId: string;
    updateBuyerAddressRequest: UpdateBuyerAddressRequest;
}

export interface UserApiControllerUpdateCategoryRequest {
    userId: string;
    updateCategoryRequest: UpdateCategoryRequest;
}

export interface UserApiControllerUpdateSellerAddressRequest {
    userId: string;
    addressRequest: AddressRequest;
}

export interface UserApiControllerUpdateUserRequest {
    userId: string;
    updateUserParams: UpdateUserParams;
}

export interface UserApiControllerUpdateUserCommentRequest {
    userId: string;
    updateBlockUserCommentRequest: UpdateBlockUserCommentRequest;
}

export interface UserApiControllerUpdateUserPhoneNumberRequest {
    userId: string;
    updateUserPhoneNumber: UpdateUserPhoneNumber;
}

export interface UserApiControllerUpdateUserV2Request {
    userId: string;
    updateUserParamsV2: UpdateUserParamsV2;
}

export interface UserApiControllerUpdateWithdrawableBalanceByAdminRequest {
    userId: string;
    updateWithdrawableBalanceByAdminRequest: UpdateWithdrawableBalanceByAdminRequest;
}

export interface UserApiControllerValidateUsernameRequest {
    userId: string;
    validateUsername: ValidateUsername;
}

export interface UserApiControllerWatchSellerRequest {
    userId: string;
    watchSellerRequest: WatchSellerRequest;
}

export interface UserApiControllerWatchSellerV2Request {
    sellerId: string;
}

export interface UserDashboardAccessApiControllerGetAccessRequest {
    userId: string;
}

export interface UserDashboardAccessApiControllerUpdateAccessRequest {
    userId: string;
    updateRequest: UpdateRequest;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     */
    async userApiControllerAddUserToBlockListRaw(requestParameters: UserApiControllerAddUserToBlockListRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerAddUserToBlockList.');
        }

        if (requestParameters.blockedUserId === null || requestParameters.blockedUserId === undefined) {
            throw new runtime.RequiredError('blockedUserId','Required parameter requestParameters.blockedUserId was null or undefined when calling userApiControllerAddUserToBlockList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/blocked-users/{blockedUserId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"blockedUserId"}}`, encodeURIComponent(String(requestParameters.blockedUserId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerAddUserToBlockList(requestParameters: UserApiControllerAddUserToBlockListRequest): Promise<void> {
        await this.userApiControllerAddUserToBlockListRaw(requestParameters);
    }

    /**
     */
    async userApiControllerApplyChangePayoutMethodRaw(requestParameters: UserApiControllerApplyChangePayoutMethodRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerApplyChangePayoutMethod.');
        }

        if (requestParameters.applyChangePayoutMethodDto === null || requestParameters.applyChangePayoutMethodDto === undefined) {
            throw new runtime.RequiredError('applyChangePayoutMethodDto','Required parameter requestParameters.applyChangePayoutMethodDto was null or undefined when calling userApiControllerApplyChangePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:applyChangePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.applyChangePayoutMethodDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerApplyChangePayoutMethod(requestParameters: UserApiControllerApplyChangePayoutMethodRequest): Promise<void> {
        await this.userApiControllerApplyChangePayoutMethodRaw(requestParameters);
    }

    /**
     */
    async userApiControllerApplyChangeStripePayoutMethodRaw(requestParameters: UserApiControllerApplyChangeStripePayoutMethodRequest): Promise<runtime.ApiResponse<EditStripePayoutMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerApplyChangeStripePayoutMethod.');
        }

        if (requestParameters.applyStripePayoutMethodRequest === null || requestParameters.applyStripePayoutMethodRequest === undefined) {
            throw new runtime.RequiredError('applyStripePayoutMethodRequest','Required parameter requestParameters.applyStripePayoutMethodRequest was null or undefined when calling userApiControllerApplyChangeStripePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:applyChangeStripePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.applyStripePayoutMethodRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerApplyChangeStripePayoutMethod(requestParameters: UserApiControllerApplyChangeStripePayoutMethodRequest): Promise<EditStripePayoutMethodResponse> {
        const response = await this.userApiControllerApplyChangeStripePayoutMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerApproveChangePayoutMethodRaw(requestParameters: UserApiControllerApproveChangePayoutMethodRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerApproveChangePayoutMethod.');
        }

        if (requestParameters.auditChangePayoutMethodDto === null || requestParameters.auditChangePayoutMethodDto === undefined) {
            throw new runtime.RequiredError('auditChangePayoutMethodDto','Required parameter requestParameters.auditChangePayoutMethodDto was null or undefined when calling userApiControllerApproveChangePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:approveChangePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.auditChangePayoutMethodDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerApproveChangePayoutMethod(requestParameters: UserApiControllerApproveChangePayoutMethodRequest): Promise<void> {
        await this.userApiControllerApproveChangePayoutMethodRaw(requestParameters);
    }

    /**
     */
    async userApiControllerBlockAccessSourceRaw(requestParameters: UserApiControllerBlockAccessSourceRequest): Promise<runtime.ApiResponse<BlockAccessSourceResponse>> {
        if (requestParameters.blockAccessSource === null || requestParameters.blockAccessSource === undefined) {
            throw new runtime.RequiredError('blockAccessSource','Required parameter requestParameters.blockAccessSource was null or undefined when calling userApiControllerBlockAccessSource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/block-access-sources`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.blockAccessSource,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerBlockAccessSource(requestParameters: UserApiControllerBlockAccessSourceRequest): Promise<BlockAccessSourceResponse> {
        const response = await this.userApiControllerBlockAccessSourceRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerBlockUserCommentRaw(requestParameters: UserApiControllerBlockUserCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerBlockUserComment.');
        }

        if (requestParameters.blockUserCommentRequest === null || requestParameters.blockUserCommentRequest === undefined) {
            throw new runtime.RequiredError('blockUserCommentRequest','Required parameter requestParameters.blockUserCommentRequest was null or undefined when calling userApiControllerBlockUserComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:block-comment`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.blockUserCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerBlockUserComment(requestParameters: UserApiControllerBlockUserCommentRequest): Promise<void> {
        await this.userApiControllerBlockUserCommentRaw(requestParameters);
    }

    /**
     */
    async userApiControllerCheckPayoutMethodUpdateStatusRaw(requestParameters: UserApiControllerCheckPayoutMethodUpdateStatusRequest): Promise<runtime.ApiResponse<CheckPayoutMethodUpdateStatusResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCheckPayoutMethodUpdateStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:checkPayoutMethodUpdateStatus`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCheckPayoutMethodUpdateStatus(requestParameters: UserApiControllerCheckPayoutMethodUpdateStatusRequest): Promise<CheckPayoutMethodUpdateStatusResponse> {
        const response = await this.userApiControllerCheckPayoutMethodUpdateStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerCheckUserDefaultAddressRaw(requestParameters: UserApiControllerCheckUserDefaultAddressRequest): Promise<runtime.ApiResponse<EnsureAddressResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCheckUserDefaultAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:ensure-address`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCheckUserDefaultAddress(requestParameters: UserApiControllerCheckUserDefaultAddressRequest): Promise<EnsureAddressResponse> {
        const response = await this.userApiControllerCheckUserDefaultAddressRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateFollowerRaw(requestParameters: UserApiControllerCreateFollowerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCreateFollower.');
        }

        if (requestParameters.createFollowerDto === null || requestParameters.createFollowerDto === undefined) {
            throw new runtime.RequiredError('createFollowerDto','Required parameter requestParameters.createFollowerDto was null or undefined when calling userApiControllerCreateFollower.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/followers`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createFollowerDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateFollower(requestParameters: UserApiControllerCreateFollowerRequest): Promise<void> {
        await this.userApiControllerCreateFollowerRaw(requestParameters);
    }

    /**
     */
    async userApiControllerCreateGuestUserRaw(requestParameters: UserApiControllerCreateGuestUserRequest): Promise<runtime.ApiResponse<AuthTokenResponse>> {
        if (requestParameters.createGuestUserRequest === null || requestParameters.createGuestUserRequest === undefined) {
            throw new runtime.RequiredError('createGuestUserRequest','Required parameter requestParameters.createGuestUserRequest was null or undefined when calling userApiControllerCreateGuestUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/guest-users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createGuestUserRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateGuestUser(requestParameters: UserApiControllerCreateGuestUserRequest): Promise<AuthTokenResponse> {
        const response = await this.userApiControllerCreateGuestUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateOneTimeLoginCodeRaw(): Promise<runtime.ApiResponse<OneTimeLoginCodeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/one-time-login-codes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateOneTimeLoginCode(): Promise<OneTimeLoginCodeDto> {
        const response = await this.userApiControllerCreateOneTimeLoginCodeRaw();
        return await response.value();
    }

    /**
     */
    async userApiControllerCreatePayoutMethodRaw(requestParameters: UserApiControllerCreatePayoutMethodRequest): Promise<runtime.ApiResponse<CreatePayoutMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCreatePayoutMethod.');
        }

        if (requestParameters.createPayoutMethodDto === null || requestParameters.createPayoutMethodDto === undefined) {
            throw new runtime.RequiredError('createPayoutMethodDto','Required parameter requestParameters.createPayoutMethodDto was null or undefined when calling userApiControllerCreatePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:createPayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPayoutMethodDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreatePayoutMethod(requestParameters: UserApiControllerCreatePayoutMethodRequest): Promise<CreatePayoutMethodResponse> {
        const response = await this.userApiControllerCreatePayoutMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateRoleRaw(requestParameters: UserApiControllerCreateRoleRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCreateRole.');
        }

        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling userApiControllerCreateRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/roles/{role}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateRole(requestParameters: UserApiControllerCreateRoleRequest): Promise<void> {
        await this.userApiControllerCreateRoleRaw(requestParameters);
    }

    /**
     */
    async userApiControllerCreateStripePayoutMethodRaw(requestParameters: UserApiControllerCreateStripePayoutMethodRequest): Promise<runtime.ApiResponse<CreateStripePayoutMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCreateStripePayoutMethod.');
        }

        if (requestParameters.createStripePayoutMethodRequest === null || requestParameters.createStripePayoutMethodRequest === undefined) {
            throw new runtime.RequiredError('createStripePayoutMethodRequest','Required parameter requestParameters.createStripePayoutMethodRequest was null or undefined when calling userApiControllerCreateStripePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:createStripePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createStripePayoutMethodRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateStripePayoutMethod(requestParameters: UserApiControllerCreateStripePayoutMethodRequest): Promise<CreateStripePayoutMethodResponse> {
        const response = await this.userApiControllerCreateStripePayoutMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateUserV2Raw(requestParameters: UserApiControllerCreateUserV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerCreateUserV2.');
        }

        if (requestParameters.createUserParamsV2 === null || requestParameters.createUserParamsV2 === undefined) {
            throw new runtime.RequiredError('createUserParamsV2','Required parameter requestParameters.createUserParamsV2 was null or undefined when calling userApiControllerCreateUserV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUserParamsV2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateUserV2(requestParameters: UserApiControllerCreateUserV2Request): Promise<void> {
        await this.userApiControllerCreateUserV2Raw(requestParameters);
    }

    /**
     */
    async userApiControllerDeleteRoleRaw(requestParameters: UserApiControllerDeleteRoleRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerDeleteRole.');
        }

        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling userApiControllerDeleteRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/roles/{role}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerDeleteRole(requestParameters: UserApiControllerDeleteRoleRequest): Promise<void> {
        await this.userApiControllerDeleteRoleRaw(requestParameters);
    }

    /**
     */
    async userApiControllerExchangeOneTimeLoginCodeRaw(requestParameters: UserApiControllerExchangeOneTimeLoginCodeRequest): Promise<runtime.ApiResponse<AuthTokenResponse>> {
        if (requestParameters.oneTimeLoginCodeDto === null || requestParameters.oneTimeLoginCodeDto === undefined) {
            throw new runtime.RequiredError('oneTimeLoginCodeDto','Required parameter requestParameters.oneTimeLoginCodeDto was null or undefined when calling userApiControllerExchangeOneTimeLoginCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/one-time-login-codes:exchange`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.oneTimeLoginCodeDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerExchangeOneTimeLoginCode(requestParameters: UserApiControllerExchangeOneTimeLoginCodeRequest): Promise<AuthTokenResponse> {
        const response = await this.userApiControllerExchangeOneTimeLoginCodeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerExecuteClaimActionRaw(requestParameters: UserApiControllerExecuteClaimActionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerExecuteClaimAction.');
        }

        if (requestParameters.executeClaimActionRequest === null || requestParameters.executeClaimActionRequest === undefined) {
            throw new runtime.RequiredError('executeClaimActionRequest','Required parameter requestParameters.executeClaimActionRequest was null or undefined when calling userApiControllerExecuteClaimAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:set-invited-by`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.executeClaimActionRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerExecuteClaimAction(requestParameters: UserApiControllerExecuteClaimActionRequest): Promise<void> {
        await this.userApiControllerExecuteClaimActionRaw(requestParameters);
    }

    /**
     */
    async userApiControllerGetAccessSourcesRaw(requestParameters: UserApiControllerGetAccessSourcesRequest): Promise<runtime.ApiResponse<AccessSourceResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetAccessSources.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getAccessSources`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetAccessSources(requestParameters: UserApiControllerGetAccessSourcesRequest): Promise<AccessSourceResponse> {
        const response = await this.userApiControllerGetAccessSourcesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetAuthInfoRaw(requestParameters: UserApiControllerGetAuthInfoRequest): Promise<runtime.ApiResponse<AuthUserItem>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetAuthInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getUserInfo`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetAuthInfo(requestParameters: UserApiControllerGetAuthInfoRequest): Promise<AuthUserItem> {
        const response = await this.userApiControllerGetAuthInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetBalanceRaw(requestParameters: UserApiControllerGetBalanceRequest): Promise<runtime.ApiResponse<SellerBalanceResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getSellerBalance`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetBalance(requestParameters: UserApiControllerGetBalanceRequest): Promise<SellerBalanceResponse> {
        const response = await this.userApiControllerGetBalanceRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetFeaturesRaw(requestParameters: UserApiControllerGetFeaturesRequest): Promise<runtime.ApiResponse<GetFeatureResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetFeatures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getFeatures`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetFeatures(requestParameters: UserApiControllerGetFeaturesRequest): Promise<GetFeatureResponse> {
        const response = await this.userApiControllerGetFeaturesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetLatestAppSellerApplicationRaw(requestParameters: UserApiControllerGetLatestAppSellerApplicationRequest): Promise<runtime.ApiResponse<AppSellerApplicationResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetLatestAppSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getLatestAppSellerApplication`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetLatestAppSellerApplication(requestParameters: UserApiControllerGetLatestAppSellerApplicationRequest): Promise<AppSellerApplicationResponse> {
        const response = await this.userApiControllerGetLatestAppSellerApplicationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetPhoneRaw(requestParameters: UserApiControllerGetPhoneRequest): Promise<runtime.ApiResponse<GetPhoneResponse>> {
        if (requestParameters.phone === null || requestParameters.phone === undefined) {
            throw new runtime.RequiredError('phone','Required parameter requestParameters.phone was null or undefined when calling userApiControllerGetPhone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-phones/{phone}`.replace(`{${"phone"}}`, encodeURIComponent(String(requestParameters.phone))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetPhone(requestParameters: UserApiControllerGetPhoneRequest): Promise<GetPhoneResponse> {
        const response = await this.userApiControllerGetPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async userApiControllerGetPublicFeaturesRaw(requestParameters: UserApiControllerGetPublicFeaturesRequest): Promise<runtime.ApiResponse<GetPublicFeatureResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetPublicFeatures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/public-features`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async userApiControllerGetPublicFeatures(requestParameters: UserApiControllerGetPublicFeaturesRequest): Promise<GetPublicFeatureResponse> {
        const response = await this.userApiControllerGetPublicFeaturesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async userApiControllerGetSellerMetricsRaw(requestParameters: UserApiControllerGetSellerMetricsRequest): Promise<runtime.ApiResponse<GetSellerMetricsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling userApiControllerGetSellerMetrics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/metrics`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async userApiControllerGetSellerMetrics(requestParameters: UserApiControllerGetSellerMetricsRequest): Promise<GetSellerMetricsResponse> {
        const response = await this.userApiControllerGetSellerMetricsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetStripePayoutMethodRaw(requestParameters: UserApiControllerGetStripePayoutMethodRequest): Promise<runtime.ApiResponse<StripePayoutMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetStripePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:stripePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetStripePayoutMethod(requestParameters: UserApiControllerGetStripePayoutMethodRequest): Promise<StripePayoutMethodResponse> {
        const response = await this.userApiControllerGetStripePayoutMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetUserLastLoginSessionRaw(requestParameters: UserApiControllerGetUserLastLoginSessionRequest): Promise<runtime.ApiResponse<LoginSessionResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetUserLastLoginSession.');
        }

        if (requestParameters.appId === null || requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId','Required parameter requestParameters.appId was null or undefined when calling userApiControllerGetUserLastLoginSession.');
        }

        const queryParameters: any = {};

        if (requestParameters.appId !== undefined) {
            queryParameters['appId'] = requestParameters.appId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:getLastLoginSession`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetUserLastLoginSession(requestParameters: UserApiControllerGetUserLastLoginSessionRequest): Promise<LoginSessionResponse> {
        const response = await this.userApiControllerGetUserLastLoginSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async userApiControllerGetUserMetricsRaw(requestParameters: UserApiControllerGetUserMetricsRequest): Promise<runtime.ApiResponse<GetUserMetricsResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetUserMetrics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/metrics`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async userApiControllerGetUserMetrics(requestParameters: UserApiControllerGetUserMetricsRequest): Promise<GetUserMetricsResponse> {
        const response = await this.userApiControllerGetUserMetricsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetUserTokenRaw(requestParameters: UserApiControllerGetUserTokenRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerGetUserToken.');
        }

        if (requestParameters.getUserTokenRequest === null || requestParameters.getUserTokenRequest === undefined) {
            throw new runtime.RequiredError('getUserTokenRequest','Required parameter requestParameters.getUserTokenRequest was null or undefined when calling userApiControllerGetUserToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:generateToken`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getUserTokenRequest,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userApiControllerGetUserToken(requestParameters: UserApiControllerGetUserTokenRequest): Promise<string> {
        const response = await this.userApiControllerGetUserTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerJoinCommunityListRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/community-waitlist-users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerJoinCommunityList(): Promise<void> {
        await this.userApiControllerJoinCommunityListRaw();
    }

    /**
     */
    async userApiControllerLinkRaw(requestParameters: UserApiControllerLinkRequest): Promise<runtime.ApiResponse<LinkAccountResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerLink.');
        }

        if (requestParameters.linkUserDto === null || requestParameters.linkUserDto === undefined) {
            throw new runtime.RequiredError('linkUserDto','Required parameter requestParameters.linkUserDto was null or undefined when calling userApiControllerLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:link`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.linkUserDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerLink(requestParameters: UserApiControllerLinkRequest): Promise<LinkAccountResponse> {
        const response = await this.userApiControllerLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerLoginRaw(requestParameters: UserApiControllerLoginRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerLogin.');
        }

        if (requestParameters.loginRequest === null || requestParameters.loginRequest === undefined) {
            throw new runtime.RequiredError('loginRequest','Required parameter requestParameters.loginRequest was null or undefined when calling userApiControllerLogin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:login`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.loginRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerLogin(requestParameters: UserApiControllerLoginRequest): Promise<void> {
        await this.userApiControllerLoginRaw(requestParameters);
    }

    /**
     */
    async userApiControllerLogoutRaw(requestParameters: UserApiControllerLogoutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerLogout.');
        }

        if (requestParameters.logoutRequest === null || requestParameters.logoutRequest === undefined) {
            throw new runtime.RequiredError('logoutRequest','Required parameter requestParameters.logoutRequest was null or undefined when calling userApiControllerLogout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:logout`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.logoutRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerLogout(requestParameters: UserApiControllerLogoutRequest): Promise<void> {
        await this.userApiControllerLogoutRaw(requestParameters);
    }

    /**
     */
    async userApiControllerMergeAccountRaw(requestParameters: UserApiControllerMergeAccountRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerMergeAccount.');
        }

        if (requestParameters.mergeAccountDto === null || requestParameters.mergeAccountDto === undefined) {
            throw new runtime.RequiredError('mergeAccountDto','Required parameter requestParameters.mergeAccountDto was null or undefined when calling userApiControllerMergeAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:merge`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mergeAccountDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerMergeAccount(requestParameters: UserApiControllerMergeAccountRequest): Promise<void> {
        await this.userApiControllerMergeAccountRaw(requestParameters);
    }

    /**
     */
    async userApiControllerModifyReceivedGiftListingRaw(requestParameters: UserApiControllerModifyReceivedGiftListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.receiverId === null || requestParameters.receiverId === undefined) {
            throw new runtime.RequiredError('receiverId','Required parameter requestParameters.receiverId was null or undefined when calling userApiControllerModifyReceivedGiftListing.');
        }

        if (requestParameters.sentReferralGiftId === null || requestParameters.sentReferralGiftId === undefined) {
            throw new runtime.RequiredError('sentReferralGiftId','Required parameter requestParameters.sentReferralGiftId was null or undefined when calling userApiControllerModifyReceivedGiftListing.');
        }

        if (requestParameters.modifyReceivedGiftListingRequest === null || requestParameters.modifyReceivedGiftListingRequest === undefined) {
            throw new runtime.RequiredError('modifyReceivedGiftListingRequest','Required parameter requestParameters.modifyReceivedGiftListingRequest was null or undefined when calling userApiControllerModifyReceivedGiftListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{receiverId}/sentReferralGifts/{sentReferralGiftId}:modifyListing`.replace(`{${"receiverId"}}`, encodeURIComponent(String(requestParameters.receiverId))).replace(`{${"sentReferralGiftId"}}`, encodeURIComponent(String(requestParameters.sentReferralGiftId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.modifyReceivedGiftListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerModifyReceivedGiftListing(requestParameters: UserApiControllerModifyReceivedGiftListingRequest): Promise<void> {
        await this.userApiControllerModifyReceivedGiftListingRaw(requestParameters);
    }

    /**
     */
    async userApiControllerPatchReadonlyProfileRaw(requestParameters: UserApiControllerPatchReadonlyProfileRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerPatchReadonlyProfile.');
        }

        if (requestParameters.patchReadonlyProfileRequest === null || requestParameters.patchReadonlyProfileRequest === undefined) {
            throw new runtime.RequiredError('patchReadonlyProfileRequest','Required parameter requestParameters.patchReadonlyProfileRequest was null or undefined when calling userApiControllerPatchReadonlyProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/readonly-profile/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchReadonlyProfileRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerPatchReadonlyProfile(requestParameters: UserApiControllerPatchReadonlyProfileRequest): Promise<void> {
        await this.userApiControllerPatchReadonlyProfileRaw(requestParameters);
    }

    /**
     */
    async userApiControllerRejectChangePayoutMethodRaw(requestParameters: UserApiControllerRejectChangePayoutMethodRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerRejectChangePayoutMethod.');
        }

        if (requestParameters.auditChangePayoutMethodDto === null || requestParameters.auditChangePayoutMethodDto === undefined) {
            throw new runtime.RequiredError('auditChangePayoutMethodDto','Required parameter requestParameters.auditChangePayoutMethodDto was null or undefined when calling userApiControllerRejectChangePayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:rejectChangePayoutMethod`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.auditChangePayoutMethodDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerRejectChangePayoutMethod(requestParameters: UserApiControllerRejectChangePayoutMethodRequest): Promise<void> {
        await this.userApiControllerRejectChangePayoutMethodRaw(requestParameters);
    }

    /**
     */
    async userApiControllerRemoveFollowerRaw(requestParameters: UserApiControllerRemoveFollowerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerRemoveFollower.');
        }

        if (requestParameters.followerId === null || requestParameters.followerId === undefined) {
            throw new runtime.RequiredError('followerId','Required parameter requestParameters.followerId was null or undefined when calling userApiControllerRemoveFollower.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/followers/{followerId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"followerId"}}`, encodeURIComponent(String(requestParameters.followerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerRemoveFollower(requestParameters: UserApiControllerRemoveFollowerRequest): Promise<void> {
        await this.userApiControllerRemoveFollowerRaw(requestParameters);
    }

    /**
     */
    async userApiControllerRemoveUserFromBlockListRaw(requestParameters: UserApiControllerRemoveUserFromBlockListRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerRemoveUserFromBlockList.');
        }

        if (requestParameters.blockedUserId === null || requestParameters.blockedUserId === undefined) {
            throw new runtime.RequiredError('blockedUserId','Required parameter requestParameters.blockedUserId was null or undefined when calling userApiControllerRemoveUserFromBlockList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/blocked-users/{blockedUserId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"blockedUserId"}}`, encodeURIComponent(String(requestParameters.blockedUserId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerRemoveUserFromBlockList(requestParameters: UserApiControllerRemoveUserFromBlockListRequest): Promise<void> {
        await this.userApiControllerRemoveUserFromBlockListRaw(requestParameters);
    }

    /**
     */
    async userApiControllerRestoreUserCommentRaw(requestParameters: UserApiControllerRestoreUserCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerRestoreUserComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:allow-comment`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerRestoreUserComment(requestParameters: UserApiControllerRestoreUserCommentRequest): Promise<void> {
        await this.userApiControllerRestoreUserCommentRaw(requestParameters);
    }

    /**
     */
    async userApiControllerReverseMergeAccountRaw(requestParameters: UserApiControllerReverseMergeAccountRequest): Promise<runtime.ApiResponse<AuthTokenResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerReverseMergeAccount.');
        }

        if (requestParameters.mergeAccountDto === null || requestParameters.mergeAccountDto === undefined) {
            throw new runtime.RequiredError('mergeAccountDto','Required parameter requestParameters.mergeAccountDto was null or undefined when calling userApiControllerReverseMergeAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:reverseMerge`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mergeAccountDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerReverseMergeAccount(requestParameters: UserApiControllerReverseMergeAccountRequest): Promise<AuthTokenResponse> {
        const response = await this.userApiControllerReverseMergeAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerSetPayoutMethodRaw(requestParameters: UserApiControllerSetPayoutMethodRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerSetPayoutMethod.');
        }

        if (requestParameters.setPayoutMethodDto === null || requestParameters.setPayoutMethodDto === undefined) {
            throw new runtime.RequiredError('setPayoutMethodDto','Required parameter requestParameters.setPayoutMethodDto was null or undefined when calling userApiControllerSetPayoutMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:set-payout-method`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setPayoutMethodDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerSetPayoutMethod(requestParameters: UserApiControllerSetPayoutMethodRequest): Promise<void> {
        await this.userApiControllerSetPayoutMethodRaw(requestParameters);
    }

    /**
     */
    async userApiControllerSetProfileUrlCodeRaw(requestParameters: UserApiControllerSetProfileUrlCodeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerSetProfileUrlCode.');
        }

        if (requestParameters.setUrlCodeDto === null || requestParameters.setUrlCodeDto === undefined) {
            throw new runtime.RequiredError('setUrlCodeDto','Required parameter requestParameters.setUrlCodeDto was null or undefined when calling userApiControllerSetProfileUrlCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:set-url-code`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setUrlCodeDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerSetProfileUrlCode(requestParameters: UserApiControllerSetProfileUrlCodeRequest): Promise<void> {
        await this.userApiControllerSetProfileUrlCodeRaw(requestParameters);
    }

    /**
     */
    async userApiControllerSetUserPasswordRaw(requestParameters: UserApiControllerSetUserPasswordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerSetUserPassword.');
        }

        if (requestParameters.setUserPasswordRequest === null || requestParameters.setUserPasswordRequest === undefined) {
            throw new runtime.RequiredError('setUserPasswordRequest','Required parameter requestParameters.setUserPasswordRequest was null or undefined when calling userApiControllerSetUserPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:setPassword`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setUserPasswordRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerSetUserPassword(requestParameters: UserApiControllerSetUserPasswordRequest): Promise<void> {
        await this.userApiControllerSetUserPasswordRaw(requestParameters);
    }

    /**
     */
    async userApiControllerSetUserReferrerRaw(requestParameters: UserApiControllerSetUserReferrerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerSetUserReferrer.');
        }

        if (requestParameters.setReferrerRequest === null || requestParameters.setReferrerRequest === undefined) {
            throw new runtime.RequiredError('setReferrerRequest','Required parameter requestParameters.setReferrerRequest was null or undefined when calling userApiControllerSetUserReferrer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:setReferrer`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setReferrerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerSetUserReferrer(requestParameters: UserApiControllerSetUserReferrerRequest): Promise<void> {
        await this.userApiControllerSetUserReferrerRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUnblockAccessSourceRaw(requestParameters: UserApiControllerUnblockAccessSourceRequest): Promise<runtime.ApiResponse<UnBlockAccessSourceResponse>> {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) {
            throw new runtime.RequiredError('sourceId','Required parameter requestParameters.sourceId was null or undefined when calling userApiControllerUnblockAccessSource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/block-access-sources/{sourceId}`.replace(`{${"sourceId"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerUnblockAccessSource(requestParameters: UserApiControllerUnblockAccessSourceRequest): Promise<UnBlockAccessSourceResponse> {
        const response = await this.userApiControllerUnblockAccessSourceRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerUnlinkSignInProvidersRaw(requestParameters: UserApiControllerUnlinkSignInProvidersRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUnlinkSignInProviders.');
        }

        if (requestParameters.unlinkSignInProvidersRequest === null || requestParameters.unlinkSignInProvidersRequest === undefined) {
            throw new runtime.RequiredError('unlinkSignInProvidersRequest','Required parameter requestParameters.unlinkSignInProvidersRequest was null or undefined when calling userApiControllerUnlinkSignInProviders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:unlink`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unlinkSignInProvidersRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUnlinkSignInProviders(requestParameters: UserApiControllerUnlinkSignInProvidersRequest): Promise<void> {
        await this.userApiControllerUnlinkSignInProvidersRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateBuyerAddressRaw(requestParameters: UserApiControllerUpdateBuyerAddressRequest): Promise<runtime.ApiResponse<UpdateAddressResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateBuyerAddress.');
        }

        if (requestParameters.updateBuyerAddressRequest === null || requestParameters.updateBuyerAddressRequest === undefined) {
            throw new runtime.RequiredError('updateBuyerAddressRequest','Required parameter requestParameters.updateBuyerAddressRequest was null or undefined when calling userApiControllerUpdateBuyerAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:update-buyer-address`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateBuyerAddressRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateBuyerAddress(requestParameters: UserApiControllerUpdateBuyerAddressRequest): Promise<UpdateAddressResponse> {
        const response = await this.userApiControllerUpdateBuyerAddressRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerUpdateCategoryRaw(requestParameters: UserApiControllerUpdateCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateCategory.');
        }

        if (requestParameters.updateCategoryRequest === null || requestParameters.updateCategoryRequest === undefined) {
            throw new runtime.RequiredError('updateCategoryRequest','Required parameter requestParameters.updateCategoryRequest was null or undefined when calling userApiControllerUpdateCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:updateCategory`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateCategory(requestParameters: UserApiControllerUpdateCategoryRequest): Promise<void> {
        await this.userApiControllerUpdateCategoryRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateSellerAddressRaw(requestParameters: UserApiControllerUpdateSellerAddressRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateSellerAddress.');
        }

        if (requestParameters.addressRequest === null || requestParameters.addressRequest === undefined) {
            throw new runtime.RequiredError('addressRequest','Required parameter requestParameters.addressRequest was null or undefined when calling userApiControllerUpdateSellerAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:update-seller-address`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addressRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateSellerAddress(requestParameters: UserApiControllerUpdateSellerAddressRequest): Promise<void> {
        await this.userApiControllerUpdateSellerAddressRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateUserRaw(requestParameters: UserApiControllerUpdateUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateUser.');
        }

        if (requestParameters.updateUserParams === null || requestParameters.updateUserParams === undefined) {
            throw new runtime.RequiredError('updateUserParams','Required parameter requestParameters.updateUserParams was null or undefined when calling userApiControllerUpdateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserParams,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateUser(requestParameters: UserApiControllerUpdateUserRequest): Promise<void> {
        await this.userApiControllerUpdateUserRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateUserCommentRaw(requestParameters: UserApiControllerUpdateUserCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateUserComment.');
        }

        if (requestParameters.updateBlockUserCommentRequest === null || requestParameters.updateBlockUserCommentRequest === undefined) {
            throw new runtime.RequiredError('updateBlockUserCommentRequest','Required parameter requestParameters.updateBlockUserCommentRequest was null or undefined when calling userApiControllerUpdateUserComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:updateBlockComment`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateBlockUserCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateUserComment(requestParameters: UserApiControllerUpdateUserCommentRequest): Promise<void> {
        await this.userApiControllerUpdateUserCommentRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateUserPhoneNumberRaw(requestParameters: UserApiControllerUpdateUserPhoneNumberRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateUserPhoneNumber.');
        }

        if (requestParameters.updateUserPhoneNumber === null || requestParameters.updateUserPhoneNumber === undefined) {
            throw new runtime.RequiredError('updateUserPhoneNumber','Required parameter requestParameters.updateUserPhoneNumber was null or undefined when calling userApiControllerUpdateUserPhoneNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:updatePhoneNumber`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserPhoneNumber,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateUserPhoneNumber(requestParameters: UserApiControllerUpdateUserPhoneNumberRequest): Promise<void> {
        await this.userApiControllerUpdateUserPhoneNumberRaw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateUserV2Raw(requestParameters: UserApiControllerUpdateUserV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateUserV2.');
        }

        if (requestParameters.updateUserParamsV2 === null || requestParameters.updateUserParamsV2 === undefined) {
            throw new runtime.RequiredError('updateUserParamsV2','Required parameter requestParameters.updateUserParamsV2 was null or undefined when calling userApiControllerUpdateUserV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserParamsV2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateUserV2(requestParameters: UserApiControllerUpdateUserV2Request): Promise<void> {
        await this.userApiControllerUpdateUserV2Raw(requestParameters);
    }

    /**
     */
    async userApiControllerUpdateWithdrawableBalanceByAdminRaw(requestParameters: UserApiControllerUpdateWithdrawableBalanceByAdminRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerUpdateWithdrawableBalanceByAdmin.');
        }

        if (requestParameters.updateWithdrawableBalanceByAdminRequest === null || requestParameters.updateWithdrawableBalanceByAdminRequest === undefined) {
            throw new runtime.RequiredError('updateWithdrawableBalanceByAdminRequest','Required parameter requestParameters.updateWithdrawableBalanceByAdminRequest was null or undefined when calling userApiControllerUpdateWithdrawableBalanceByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:update-withdrawable-balance`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateWithdrawableBalanceByAdminRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateWithdrawableBalanceByAdmin(requestParameters: UserApiControllerUpdateWithdrawableBalanceByAdminRequest): Promise<void> {
        await this.userApiControllerUpdateWithdrawableBalanceByAdminRaw(requestParameters);
    }

    /**
     */
    async userApiControllerValidateUsernameRaw(requestParameters: UserApiControllerValidateUsernameRequest): Promise<runtime.ApiResponse<ValidateUsernameResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerValidateUsername.');
        }

        if (requestParameters.validateUsername === null || requestParameters.validateUsername === undefined) {
            throw new runtime.RequiredError('validateUsername','Required parameter requestParameters.validateUsername was null or undefined when calling userApiControllerValidateUsername.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{userId}:validateUsername`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.validateUsername,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerValidateUsername(requestParameters: UserApiControllerValidateUsernameRequest): Promise<ValidateUsernameResponse> {
        const response = await this.userApiControllerValidateUsernameRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userApiControllerWatchSellerRaw(requestParameters: UserApiControllerWatchSellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userApiControllerWatchSeller.');
        }

        if (requestParameters.watchSellerRequest === null || requestParameters.watchSellerRequest === undefined) {
            throw new runtime.RequiredError('watchSellerRequest','Required parameter requestParameters.watchSellerRequest was null or undefined when calling userApiControllerWatchSeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:watch`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.watchSellerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerWatchSeller(requestParameters: UserApiControllerWatchSellerRequest): Promise<void> {
        await this.userApiControllerWatchSellerRaw(requestParameters);
    }

    /**
     */
    async userApiControllerWatchSellerV2Raw(requestParameters: UserApiControllerWatchSellerV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling userApiControllerWatchSellerV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{sellerId}:watch`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerWatchSellerV2(requestParameters: UserApiControllerWatchSellerV2Request): Promise<void> {
        await this.userApiControllerWatchSellerV2Raw(requestParameters);
    }

    /**
     */
    async userDashboardAccessApiControllerGetAccessRaw(requestParameters: UserDashboardAccessApiControllerGetAccessRequest): Promise<runtime.ApiResponse<GetAccessResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userDashboardAccessApiControllerGetAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/dashboard-access`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userDashboardAccessApiControllerGetAccess(requestParameters: UserDashboardAccessApiControllerGetAccessRequest): Promise<GetAccessResponse> {
        const response = await this.userDashboardAccessApiControllerGetAccessRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDashboardAccessApiControllerUpdateAccessRaw(requestParameters: UserDashboardAccessApiControllerUpdateAccessRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userDashboardAccessApiControllerUpdateAccess.');
        }

        if (requestParameters.updateRequest === null || requestParameters.updateRequest === undefined) {
            throw new runtime.RequiredError('updateRequest','Required parameter requestParameters.updateRequest was null or undefined when calling userDashboardAccessApiControllerUpdateAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/dashboard-access`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDashboardAccessApiControllerUpdateAccess(requestParameters: UserDashboardAccessApiControllerUpdateAccessRequest): Promise<void> {
        await this.userDashboardAccessApiControllerUpdateAccessRaw(requestParameters);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum UserApiControllerCreateGuestUserXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
